import React, { FC, Fragment } from 'react';
import { Grid, TableCell, Typography } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import { ContentFragment } from 'api';
import { Separator } from 'components';
import { getProviderName, isUrl } from 'features/content/helpers';
import { Groups } from 'features/content/widgets';

import UrlMetadata from '../UrlMetadata';
import Body from '../Body';

interface IProps extends WithStyles<typeof styles> {
  content: ContentFragment;
}

const styles = () =>
  createStyles({
    provider: {
      display: 'inline-block',
    },
    cell: {
      paddingTop: 0,
      '&:not(:first-child)': {
        textAlign: 'left',
      },
    },
  });

const PostCell: FC<IProps> = ({ classes, content }) => {
  function renderProvider() {
    const name = getProviderName(content);

    return (
      <Fragment>
        {!!name && <Separator />}
        <Typography className={classes.provider}>{name}</Typography>
      </Fragment>
    );
  }

  return (
    <TableCell classes={{ body: classes.cell }}>
      <Grid container>
        <Grid item xs>
          <Grid container>
            <Grid item xs>
              <Groups groups={content.groups} />
              {renderProvider()}
            </Grid>
          </Grid>
          {isUrl(content) ? <UrlMetadata content={content} /> : <Body content={content} />}
        </Grid>
      </Grid>
    </TableCell>
  );
};

export default withStyles(styles)(PostCell);
